import { DEFAULT_SORT } from '../constants/sort';
import type { SearchParams } from '../types';

const RESULTS_PATH = '/financial-advisors/find-an-advisor';

export function buildResultsHref(params: SearchParams): string {
  const sp = new URLSearchParams();
  sp.append('q', params.q);

  const page = params.page ?? 1;
  if (page > 1) sp.append('page', String(page));

  for (const v of params.services ?? []) sp.append('services', v);
  for (const v of params.fees ?? []) sp.append('fees', v);
  for (const v of params.clientTypes ?? []) sp.append('clientTypes', v);
  for (const v of params.experience ?? []) sp.append('experience', v);

  if (params.sort !== undefined && params.sort !== DEFAULT_SORT) {
    sp.append('sort', params.sort);
  }

  return `${RESULTS_PATH}?${sp.toString()}`;
}
